// extracted by mini-css-extract-plugin
export default {"list":"FriendList_list__oI1cf","item":"FriendList_item__c-6on","name":"FriendList_name__3Gr10","Online":"FriendList_Online__oPM9b","Offline":"FriendList_Offline__n8Prq"};